export default __webpack_public_path__ + "static/media/card800.fc950419.jpg";